import { Box, Toolbar } from '@mui/material';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useAuthStore } from '@/stores/use-auth-store';

const SIDEBAR_WIDTH = 240;

export function MainLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const { isAuthenticated } = useAuthStore();

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

            {isAuthenticated && (
                <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            )}

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    transition: 'margin 225ms cubic-bezier(0.4, 0, 0.6, 1)',
                    marginLeft: isAuthenticated && sidebarOpen ? 0 : 0,
                    width: isAuthenticated && sidebarOpen ? `calc(100% - ${SIDEBAR_WIDTH}px)` : '100%',
                }}
            >
                <Toolbar />
                <Outlet />
            </Box>
        </Box>
    );
}

export default MainLayout;
